export default {
  created() {
    this.setModel()
  },
  watch: {
    dataList: {
      deep: true,
      handler() {
        this.setModel()
      },
    },
  },
  methods: {
    // 设置分隔符
    setSeparator(item) {
      // 已经有分隔符不再就不再加分隔符
      if (item.itemConfig.label?.lastIndexOf(this.separator) !== -1) return
      item.itemConfig.label += this.separator
    },
    // 获取表单值
    getParams() {
      return this.model
    },
    // 获取model对象
    setModel() {
      this.dataList.forEach((item) => {
        const { prop, value } = item.itemConfig
        const valueTemp = value === undefined || value === null ? '' : value
        this.setSeparator(item)
        this.$set(
          this.model,
          prop,
          this.model[prop] === undefined || this.model[prop] === null
            ? valueTemp
            : this.model[prop],
        )
      })
    },
    // 校验参数
    validateParams(params) {
      let errorMsg = ''
      const { keys } = params
      const { data } = params
      for (const [key, value] of Object.entries(keys)) {
        if (!value) errorMsg += ` ${key}`
      }
      if (typeof data === 'undefined') errorMsg += ' data'
      return errorMsg
    },
    // 设置模版数据formData/list/elConfig/list值
    /**
     * key: formData/list/itemConfig/prop值,必传参数
     * elConfigKeys:elConfig的某一属性或是isShow属性
     * elConfigKey:elConfigKeys对象的某一属性，必传参数,
     * data：接口数据或是本地维护的数据，必传参数
     */
    setItemData({ elConfigKeys = null, elConfigKey = null, key, data }) {
      const params = {
        keys: { key },
        data,
      }
      // 错误参数
      const errorKeys = this.validateParams(params)
      if (errorKeys.trim().length > 0) return

      const formItem =
        this.dataList &&
        this.dataList.find((item) => item.itemConfig.prop === key)

      const val3 = elConfigKey === 'isShow' ? formItem : formItem?.elConfig

      const val2 =
        elConfigKey === 'list'
          ? formItem?.elConfig?.options || formItem?.elConfig
          : val3

      const val1 = elConfigKey ? val2 : null

      const formItemKey = elConfigKeys ? formItem?.elConfig[elConfigKeys] : val1
      if (formItem && formItemKey) {
        this.$set(formItemKey, elConfigKey, data)
      }
    },
    // 获取表单或者表单项的refs
    getRefs(formItemRef) {
      if (formItemRef) {
        return this.$refs[formItemRef][0].$refs.formItem.$refs[formItemRef]
      }

      return this.$refs.form
    },
  },
}
